import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./EventDetailmenuImageSlider.css";
import { API_BASE_URL } from "../utils";

export default function EventDetailmenuImageSlider({ images }) {
  var url = `${API_BASE_URL}/master/assets/uploads/`;


  return (
    <div className="event-slider-wrapper">
      <Swiper
        spaceBetween={20}
        gap={10}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1, // small phones
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 1.2, // larger phones
            spaceBetween: 12,
          },
          640: {
            slidesPerView: 2, // small tablets
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2.5, // tablets
            spaceBetween: 18,
          },
          992: {
            slidesPerView: 3, // small laptops
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4, // desktops
            spaceBetween: 24,
          },
          1440: {
            slidesPerView: 5, // large screens
            spaceBetween: 28,
          },
        }}
        modules={[Autoplay, Pagination]}
      >
        {images?.map((imgObj, idx) => (
          <SwiperSlide key={idx}>
            <a data-fancybox="gallery" href={`${url}${imgObj.img}`}>
              <img
                src={`${url}${imgObj.img}`}
                alt={`menu-img-${idx + 1}`}
                className="event-slide-image"
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
